// Cart Drawer JavaScript
// Handles cart drawer functionality including opening, closing, and updating

// Get DOM elements
var openBtn = document.getElementById('open-cart-drawer');
var drawer = document.querySelector('.cart-drawer');
var closeBtn = document.querySelector('.cart-drawer__close');
var overlay = document.querySelector('.cart-drawer-overlay');

// Function to open the cart drawer
function openCartDrawer() {
    if (drawer) {
        drawer.classList.add('is-open');
        document.documentElement.classList.add('disable-overflow-y');
    }
}

// Function to close the cart drawer
function closeCartDrawer() {
    if (drawer) {
        drawer.classList.remove('is-open');
        document.documentElement.classList.remove('disable-overflow-y');
    }
}

// Function to update the cart drawer content
async function updateCartDrawer() {
    fetch('/?section_id=cart-drawer')
        .then(function(response) {
            return response.text();
        })
        .then(function(html) {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            var newCartDrawer = tempDiv.querySelector('.cart-drawer');
            
            if (newCartDrawer && drawer) {
                drawer.innerHTML = newCartDrawer.innerHTML;
                attachCartDrawerListeners();
            }
        })
        .catch(function(error) {
            console.error('Error refreshing cart drawer:', error);
        });
}

// Function to update cart count display
function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = count;
    });
}

// Function to update a line item quantity
async function updateLineItem(lineItemKey, quantity) {
    await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            updates: {
                [lineItemKey]: quantity
            }
        })
    });
    
    await updateCartDrawer();
    
    if (document.querySelector('.cart-main')) {
        await updateCartMain();
    }
    
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    updateCartCount(cart.item_count);
}

// Function to attach event listeners to cart drawer elements
function attachCartDrawerListeners() {
    // Close button listener
    const closeBtn = document.querySelector('.cart-drawer__close');
    if (closeBtn) {
        closeBtn.onclick = closeCartDrawer;
    }
    
    // Overlay click listener
    const overlay = document.querySelector('.cart-drawer__overlay');
    if (overlay) {
        overlay.onclick = closeCartDrawer;
    }
    
    // Escape key listener
    document.onkeyup = function(e) {
        if (e.code === 'Escape') {
            closeCartDrawer();
        }
    };
    
    // Quantity selector listeners
    document.querySelectorAll('.cart-drawer .quantity-selector').forEach(selector => {
        const minusBtn = selector.querySelector('.quantity__button--minus');
        const plusBtn = selector.querySelector('.quantity__button--plus');
        const input = selector.querySelector('input[type="number"], input[type="text"]');
        const lineItemKey = minusBtn?.dataset.lineitemKey || plusBtn?.dataset.lineitemKey || input?.dataset.itemKey;
        
        // Minus button functionality
        if (minusBtn) {
            minusBtn.onclick = async () => {
                let qty = parseInt(input.value, 10);
                if (qty > 1) {
                    await updateLineItem(lineItemKey, qty - 1);
                } else {
                    await updateLineItem(lineItemKey, 0);
                }
            };
        }
        
        // Plus button functionality
        if (plusBtn) {
            plusBtn.onclick = async () => {
                let qty = parseInt(input.value, 10);
                await updateLineItem(lineItemKey, qty + 1);
            };
        }
    });
    
    // Remove item functionality
    document.addEventListener('click', (e) => {
        const removIcon = e.target.closest('.line-item-remove');
        if (removIcon) {
            const lineItemKey = removIcon.getAttribute('key');
            if (lineItemKey) {
                updateLineItem(lineItemKey, 0);
            }
        }
    });
    
    // Checkout button functionality
    document.querySelectorAll('.cart-drawer__checkout-btn').forEach(cartButton => {
        cartButton.addEventListener('click', (e) => {
            e.preventDefault();
            const cartDrawer = cartButton.closest('.cart-drawer');
            const orderMsgWrapper = cartDrawer.querySelector('.order-message');
            let msg = orderMsgWrapper?.querySelector('.order-message-text')?.value || "";
            if(!orderMsgWrapper?.querySelector('input[type="checkbox"]:checked')) {
                msg = '';
            }
            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    attributes: { Notes: `Message: ${msg}` }
                })
                }).then(res=>res.json()).then(res=>{
                console.log(res);
                window.location.href = cartButton.getAttribute('data-checkout-url') || '/checkout';
            }).catch(err=>{
                console.error(err);
                window.location.href = cartButton.getAttribute('data-checkout-url') || '/checkout';
            });
        });
    });
}

// Add to cart form submission
document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async function(e) {
        e.preventDefault();
        
        const submitButton = form.querySelector('[type="submit"]');
        const originalText = submitButton ? (submitButton.value || submitButton.textContent) : '';
        
        // Disable button and show loading state
        if (submitButton) {
            submitButton.disabled = true;
        }
        
        if (submitButton && submitButton.tagName === 'INPUT') {
            submitButton.value = 'Adding...';
        }
        
        if (submitButton && submitButton.tagName !== 'INPUT') {
            submitButton.textContent = 'Adding...';
        }
        
        // Submit the form
        fetch('/cart/add.js', {
            method: 'post',
            body: new FormData(form)
        })
        .then(res => res.json())
        .then(async (resCart) => {
            // Trigger pixel event
            window.triggerPixel({
                eventName: 'product_added_to_cart',
                resCart
            });
            
            // Update cart
            const res = await fetch('/cart.js');
            const cart = await res.json();
            
            await updateCartDrawer();
            updateCartCount(cart.item_count);
            openCartDrawer();
            
            // Reset form
            form.reset();
            
            // Restore button state
            if (submitButton) {
                submitButton.disabled = false;
            }
            
            if (submitButton && submitButton.tagName === 'INPUT') {
                submitButton.value = originalText;
            }
            
            if (submitButton && submitButton.tagName !== 'INPUT') {
                submitButton.textContent = originalText;
            }
        })
        .catch(err => {
            alert('There was an error adding the item to your cart. Please try again.');
        });
    });
});

// Cart icon click handlers
document.querySelectorAll('.header-cart, .js-cart-link').forEach(cartIcon => {
    cartIcon.onclick = function(e) {
        e.preventDefault();
        openCartDrawer();
    };
});

// Initialize cart drawer listeners when DOM is ready
document.addEventListener('DOMContentLoaded', attachCartDrawerListeners);